import React, { Component } from 'react';
import Route from './AuthRoute';
import Button from './AuthButton';
import MenuItem from './AuthMenuItem';
import NoPermission from './NoPermission';

export let pc = []

export default class Auth extends Component {
    constructor(props) {
        super(props);
        Auth.permissionCodes.push(...this.props.permissionCodes);
        if (this.props.routeInvalidComponent) {
            Auth.routeInvalidComponent = this.props.routeInvalidComponent;
        }
    }
    componentDidMount() {

    }
    render() {
        return this.props.children;
    }
    static validate(code) {
        if (Auth.permissionCodes && Auth.permissionCodes.length > 0 && code && Auth.permissionCodes.indexOf(code) === -1) {
            return false;
        }
        return true;
    }
}
Auth.permissionCodes = [];
Auth.routeInvalidComponent = NoPermission;
Auth.Route = Route;
Auth.Button = Button;
Auth.MenuItem = MenuItem;
